import { render, staticRenderFns } from "./Transoperatorio.vue?vue&type=template&id=55091e2e&"
import script from "./Transoperatorio.vue?vue&type=script&lang=js&"
export * from "./Transoperatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports